import { useContext } from 'react'
import { ErrorContext, type ErrorContextValue } from './ErrorContext'

export function useErrorReporter(): ErrorContextValue {
  const context = useContext(ErrorContext)
  if (!context) {
    throw new Error('useErrorReporter must be used within an ErrorProvider')
  }
  return context
}
